import axios from "axios";
import { SERVER } from "./SERVER";

class RFWindowDataService {
    getAllRFWindows(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/rfwindows/`);
    }
    getAllArchived(year, token) {
        return this.getAllArchive(year, token);
    }
    getAllArchive(year, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/rfwindows/year/${year}`);
    }
    createRFWindow(data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/create/rfwindow/`, data);
    }
    getRFWindow(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/rfwindow/${id}/`);
    }
    updateRFWindow(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/rfwindow/${id}/`, data);
    }
    deleteRFWindow(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/rfwindow/${id}/`);
    }
    toggleChecked(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/rfwindow/checked/${id}/`);
    }
    toggleArchived(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/rfwindow/archive/${id}/`);
    }
    updateDueDate(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/rfwindow/due/${id}/`, data);
    }
}

export default new RFWindowDataService();
